<template>
    <Dialog v-model:visible="isVisible" header="Create New Permit" @hide="hide()" @show="show()" :dismissable="false"
        :draggable="false" :modal="true" :style="{ width: '30vw' }">
        <span v-show="errMessage" class="p-error">{{ errMessage }}</span>

        <div class="mt-3">
            <FormField v-model="changeWorks" labelName="Work" fieldClass="col-12" labelClass="col-5"
                v-if="requireCompany">
                <CustomSelect v-model="changeWorks.work" :url="this.$API_URL + 'list/work_code'" :minLength="0"
                    :filter="true" :params="{ companyCode: this.coyCodeUser }" @change="changework($event)"
                    :disabled="false" />
                <template #error>
                    <small v-if="v$.changeWorks.work.$error" class="p-error" style="display: block">
                        {{
        v$.changeWorks.work.$errors[0].$message.replace(
            "Value",
            "Work"
        )
    }}
                    </small>
                </template>
            </FormField>
            <FormField v-model="changeWorks" labelName="Permit Category" fieldClass="col-12" labelClass="col-5"
                v-if="requireCompany">
                <CustomSelect v-model="changeWorks.permitref" :url="this.$API_URL + 'list/permitref_code'"
                    :minLength="0" :filter="true" :params="{}" @change="changeCategory($event)" :disabled="false" />
                <template #error>
                    <small v-if="v$.changeWorks.permitref.$error" class="p-error" style="display: block">
                        {{
        v$.changeCompany.permitref.$errors[0].$message.replace(
                        "Value",
                        "Category Permit"
                        )
                        }}
                    </small>
                </template>
            </FormField>
        </div>


        <template #footer>
            <Button type="button" icon="pi pi-save" class="p-button p-button-success" @click="checkCoy()"
                label="Save" />
        </template>
    </Dialog>
</template>
<script>
import moment from 'moment';
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
    data() {
        return {
            v$: useVuelidate(),
            errMessage: null,
            url: this.$API_URL + "permit/initpermit",
            companyId: this.$store.getters.getCompanyId,
            modelPassword: null,
            username: this.$store.getters.getUsername,
            coyCodeUser: this.$store.getters.getCompanyCode,
            timezoneUserOffset: this.$store.getters.getTimezoneOffset,
            userTimeZoneOffset: moment().utcOffset() / 60,
            userTime: moment().format("HH:mm"),
            workdata: null,
            categorydata: null,
            editorPath: "/Permit/Editor",
            resetPassword: {
                currentPass: null,
                pass: null,
                confirmPass: null,
            },
            changeWorks: {
                work: null,
                permitref: null
            },
        };
    },
    validations() {
        return {
            changeWorks: {
                work: { required },
                permitref: { required }
            },
        };
    },
    props: {
        model: {
            type: Object,
            default: null,
        },
        userId: {
            type: String,
            default: null,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        requireCompany: {
            type: Boolean,
            default: false
        },
        initialErrorMessage: {
            type: String,
            default: ""
        },
        changeFirstLogin: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        show() {
            if (this.initialErrorMessage) {
                this.errMessage = this.initialErrorMessage;
            }
        },
        hide(changeSuccess, message) {
            this.resetPassword = {
                pass: null,
                confirmPass: null,
            };
            this.v$.$reset();
            this.errMessage = null;
            this.$emit("update:isVisible", false);
            this.$emit("hide", {
                success: changeSuccess,
                message: message
            });
        },
        passwordClass(data) {
            if (data.showPassword == undefined) {
                data.showPassword = "pi pi-eye";
            }
            data.showPassword =
                data.showPassword == "pi pi-eye-slash" ||
                    data.showPassword == undefined
                    ? "pi pi-eye"
                    : "pi pi-eye-slash";
            return data.showPassword;
        },
        passwordType(data) {
            return data == "pi pi-eye" ? "pi pi-eye-slash" : "pi pi-eye";
        },
        changework(e) {
            this.workdata = e == null ? null : e.id;
        },
        changeCategory(e) {
            this.categorydata = e == null ? null : e.id;
        },
        checkCoy() {
            this.v$.$validate();

            var self = this;

            if (!this.v$.$error) {
                this.$emit("block-ui");
                this.v$.$reset();

                this.$axios
                    .post(this.url, {
                        mode: this.$FORM_MODE_CREATE,
                        WorkId: this.workdata,
                        Category: this.categorydata,
                        TimeZoneOffset: this.timezoneUserOffset
                    })
                    .then((response) => {
                        if (response.data.success) {
                            //this.$router.push({ path:  "/Work/Editor" , query: { mode: "Edit", id: id } });
                            self.$emit("update:model", this.model);
                            self.hide(true, response.data);
                        } else {
                            this.errMessage = "Failed: " + response.data.message;
                        }
                        this.$emit("unblock-ui");
                    })
                    .catch((err) => {
                        this.$emit("unblock-ui");
                        self.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: err.message,
                            life: 3000,
                        });
                    });
            }
        },
    },
    emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
